export enum Layout {
  PC = 'pc',
  MOBILE = 'mobile',
}
